import { useNavigate } from "../hooks/navigateHook";
import { materializeValue } from "../utils/lazyValue";
import Button from "./Button";
import { withComponentCapabilities } from "./capabilities/componentCapabilities";
import { FloatingLabel } from "./FloatingLabel";
import Icon from "./Icon";
import PropTypes from 'prop-types';

export const customCtrlDef = {
    toString: ({ def }) => materializeValue(def.text),
    def: (t, tools) => ({
        form: [{
            borderless: true,
            rows: [
                ...tools.labelFields(t, { searchable: false }),
                [
                    { type: 'text', field: 'text', label: t('text'), required: true }
                ],
                ...tools.commonFields(t)
            ]
        }]
    }),
    control: ({ def, href, style, ...props }) => <div className={def.alignRight || def.alignEnd ? 'text-end' : null}>
        <Label text={def.text} href={href ?? def.href} style={{ ...def.style, ...style }} {...props}></Label>
    </div>
};

const LinkButton = ({ href, children }) => {
    const navigate = useNavigate();

    const handleClick = (e) => {
        e.preventDefault();
        navigate(href, { target: '_blank' });
    };

    return (
        <Button className="p-0 text-start" variant="link" onClick={handleClick}>
            <Icon variant="solid" kind="link" style={{ fontSize: '6pt' }} />
            {' '}
            {children}
        </Button>
    );
};

/**
 * Render supplied text value directly as fixed text
 * @component
 */
const Label = withComponentCapabilities(({ id, text, placeholder, href, hideLabel = false, style}) => {
    return <FloatingLabel id={id} hideLabel={hideLabel} placeholder={placeholder ?? ''} style={style} value={true} href={href}>
        {href && hideLabel ? (
                <LinkButton href={href}>{text ?? ''}</LinkButton>
            ) : (
                text ?? ''
            )}
    </FloatingLabel>
}, {
    lazyProps: ['text']
});

Label.propTypes = {
    /**
     * The text to be displayed
     */
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    /**
     * An optional field label to be shown above the text
     */
    placeholder: PropTypes.string,

    /**
     * An option navigation URL to be followed if the label text is clicked
     */
    href: PropTypes.string,

    /**
     * Collapses the floating label used for spacing
     */
    hideLabel: PropTypes.bool,
}

export default Label;